// extracted by mini-css-extract-plugin
module.exports = {"themeIcon":"AboutLinks_themeIcon__j7THD","navLinkLabel":"AboutLinks_navLinkLabel__iqOWY"};